export const CREATE_WATCH_RULE_NAME = "create_watch_rule" as const;

export const CREATE_WATCH_RULE_DESC =
  `Creates a Metric Watch rule for an analytics view or Index Worker job.

Read the project and target first. Use the exact backend units: ABSOLUTE rate thresholds use a 0..1 fraction; relative comparisons use percentage points.
When recommending a condition, consider ABSOLUTE_GREATER_THAN_OR_EQUAL with PREVIOUS_DAY, PREVIOUS_WEEK, or PREVIOUS_MONTH for monitoring both increases and decreases (±X% inclusively, nonnegative magnitude). Use GREATER_THAN or LESS_THAN when only one direction matters. Choose the comparison period that matches the user’s monitoring intent. Bidirectional monitoring requires a relative comparison; ABSOLUTE compares a raw value without a baseline.

This write operation requires user approval.` as const;
